import { Component, OnInit, ElementRef, AfterContentInit, AfterViewInit, OnChanges, DoCheck, Inject, OnDestroy  } from '@angular/core';
import { DwComponent, DwComponentType, DwContainerOptions, DwSecurityUserService, DwSectionBaseComponent, DwMetaDataGridActionState,
         DwDateTimeInputOptions, DwOrmDataServiceToken, DwOrmDataService, DwMetaDataFormStateService, DwGridEvents,
         DwMetaDataFormApi, DwEventService, DwMdEventService, DwGridEvent, DwEvent, DwMdLoadEventData, DwGridDeleteActionService,
         DwMdQueryEventData, DwContextService, DwMetaDataFilter, DwActionPreference, DwMetaDataGridApi, DwMetaDataService, DwMetaDataServiceToken,
         DwFormActionConfig, DwFormActionInterceptResult, DwInMemoryDataSource, DwFormContextMode, DwMetaDataGridPreferences, DwGridActionResult } 
         from '@devwareapps/devware-cap';
import { DwGridRefreshEventData } from '@devwareapps/devware-cap/devware-ui-metadata/grid/model/events/dw-grid-refresh-event-data.model.d';
import { FleetMetaDataItemNames, FleetMetaDataLookups, MaintenanceEntity, ServiceTypeEntity, MaintenanceServiceEntity } 
         from '../meta-data/fleet-meta-data.service';
import { FleetMaintenanceVehicleContextService } from '../data-contexts/maintenance-vehicle-context.service'
import { AppPermissions } from 'src/app/meta-data/app-permissions.enum';
import { Observable, Subscription, of } from 'rxjs';
import * as moment_ from 'moment';
const moment = moment_;

@DwComponent(
  {
    key: 'add-service-type',
    name: 'Add New Service Type',
    componentType: DwComponentType.pageComponent,
    isGlobal: true,
  }
)
@Component({
  selector: 'add-new-service-type',
  template: `
<div class="serviceType-containerClass">
    <div dwRow>
        <div dwCol="12" class="add-service-type">
            <button class="add-new" type="button" (click)="add()" class="btn-sm btn-success" title="">
                <i class="fad fa-plus-circle"></i>&nbsp;Add New Service Type</button>&nbsp;
        </div>
    </div>
    <div dwRow [hidden]="!adding" class="add-details">
        <div dwCol="12">
            <input type="text" class="type-desc" [(ngModel)]="serviceType">
            <button type="button" class="btn btn-success save-cancel" title="" (click)="save()">
                <i class="fa fa-save"></i>Save</button>
            <button type="button" class="btn btn-danger save-cancel" title="" (click)="cancel()">
                <i class="fa fa-times-circle"></i>Cancel</button>
        </div>
    </div>
</div>
  `
})
export class AddNewServiceTypeComponent 
    implements OnInit, DoCheck, OnDestroy {
  
    adding: boolean = false;
    serviceType: string = null;
    item = FleetMetaDataItemNames.ServiceType;
    formApi: DwMetaDataFormApi;
    maintenance : MaintenanceEntity;

    constructor(private dwSecurityUserService: DwSecurityUserService,
            private dwGridDeleteActionService : DwGridDeleteActionService,
            @Inject(DwMetaDataServiceToken) private dwMetaDataService : DwMetaDataService,
            @Inject(DwOrmDataServiceToken) private dataService: DwOrmDataService,
            private dwEventService: DwEventService,
            private dwContextService: DwContextService,
            private dwFormStateService: DwMetaDataFormStateService) 
    {
        this.formApi = dwFormStateService.state.formApi;
        this.maintenance = this.formApi.getFormData(); 
    }

    subscriptions: Subscription[] = [];

    save(){
        this.maintenance = this.formApi.getFormData(); 
        const nst : ServiceTypeEntity = this.dataService.createDummyEntity(FleetMetaDataItemNames.ServiceType);
        nst.Display = this.serviceType;
        this.dataService.saveEntity(nst).subscribe(i => {
            const lookupId:number = FleetMetaDataLookups.ServiceTypesAllAlphabetical;
            this.dwEventService.publishEvent(DwMetaDataService.META_DATA_EVENT_TOPICS.LookupChanged(lookupId), lookupId);
        });
        this.cancel();
    }
    cancel(){ 
        this.adding = false;
        this.serviceType = null;
    }
    add(){
        this.serviceType = null;
        this.adding = !this.adding;
    }
   
    vehicleId = null;
    ngOnInit(): void {
        if (this.formApi.getFormConfig().formMode == 'add')
            this.subscriptions.push(
                this.formApi.getFormDataChanges().subscribe(i =>{
                    if (i.MaintenanceService == undefined)
                        this.formApi.patchFormData({ MaintenanceService: []});
                    if (this.vehicleId != (i as MaintenanceEntity).VehicleId)
                        this.dwContextService.getContextsAndResolve([FleetMaintenanceVehicleContextService.ContextName], 
                                { data: i, formApi: this.formApi })
                            .subscribe();
                    this.vehicleId = (i as MaintenanceEntity).VehicleId;
                }));
    }
    ngOnDestroy(): void {
        for(const subscription of this.subscriptions) {
        subscription.unsubscribe();
        }
    }
    ngDoCheck(): void{
    }
}
